import { OfflineOrderingState } from '../types';

const removeRowItemByTempId = (state: OfflineOrderingState, menuTempId: string): OfflineOrderingState => ({
  ...state,
  menus: state.menus.filter((x) => x.tempId !== menuTempId),
});

export default removeRowItemByTempId;
